module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "press-logos"
  }, [_c('div', {
    staticClass: "our-press",
    attrs: {
      "id": "our-press"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "press-heading"
  }, [_vm._v("What the world is saying")]), _vm._v(" "), _c('span', {
    staticClass: "press-logos"
  }, _vm._l((_vm.pressContent.list), function(pressCompany, index) {
    return (index < _vm.maxImages) ? _c('a', {
      attrs: {
        "href": pressCompany.url,
        "target": "new"
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.getPressImageLogo(pressCompany.name),
        "alt": "press"
      }
    })]) : _vm._e()
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8d869362"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/site/PressHero/Press.vue
// module id = 496
// module chunks = 0